<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/MpdpQG/images/cover.jpg?1704638968069" alt="This image is the cover for the book Breach of Promise"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Breach of Promise
      </h1>
      <p class="bookDescription body article font2">
        <p>How far will a father go to get back his only daughter?  And how will he survive in a legal system that crushes those who can't afford to fight back?Mark Gillen has the storybook life other men dream of, complete with a beautiful wife and an adoring five-year-old daughter. Then his wife announces she’s leaving him. And taking their daughter with her. The other man is a famous film director with unlimited funds and the keys to stardom and wealth for Paula. How can Mark begin to compete? But the most bitter blow comes when he is kept from seeing his daughter because of false charges . . . and a legal system ill-suited for finding the truth.Forged in the darkest valley Mark has ever walked through, his faith in God may ultimately cost him everything in the eyes of the family law system. But it is the one thing that can keep him sane—and give him the strength to fight against all odds for what matters most.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        James Scott Bell
      </h2>
      
      <p class="authorDescription body article">James Scott Bell, a former trial lawyer, is the bestselling author of Try Dying, The Whole Truth, No Legal Grounds, Deadlock, and Sins of the Fathers. A winner of the Christy Award for excellence in Christian fiction, he lives in Los Angeles with his wife, Cindy. Visit his website at www.jamescottbell.com.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Zondervan
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4659ef2a